<template>
  <div class="page-content mb-8">
    <div class="bg__wrapper">
      <v-container class="app-container--width-max">
        <div class="content content--padding-small">
          <div class="bg-info text-white">
            <h2 class="font-weight-bold text--size-lg">Contact us</h2>
            <p class="mb-0">We’re here to help and support you.</p>
          </div>
        </div>
      </v-container>
    </div>

    <v-container class="block-info app-container--width-max">
      <div class="content content--padding-small pt-4">
        <v-card elevation="2" class="card__wrapper rounded-lg mt-16 mt-md-0">
          <div class="card-content">
            <h3 class="mb-5 font-weight-bold font-24">
              <v-icon large color="#69a6ac" class="mr-3">
                mdi-message-text </v-icon
              >Live chat
            </h3>
            <span>
              Get help faster! We offer a live chat and bot service to answer
              any questions you may have.
            </span>

            <div v-if="chatAvailableHours" class="d-xl-flex mt-5 mt-md-7">
              <div v-if="labelChat" class="hidden-md-and-up">
                <span class="d-block font-weight-bold mb-4">{{
                  labelChat
                }}</span>
              </div>
              <BaseButton
                depressed
                id="chat-now-btn"
                text="CHAT NOW"
                rounded
                height="60"
                dense
                class="chat_btn mr-md-8 mb-3"
                @click="openChat"
              />

              <div v-if="labelChat" class="hidden-sm-and-down">
                <span class="d-block font-weight-bold mt-4">{{
                  labelChat
                }}</span>
              </div>
              <div v-else class="text--size-small">
                <span class="d-block mb-4">
                  Our bot service is always available, however if you need to
                  chat with one of our team please contact us during the below
                  times:
                </span>
                <span class="d-block"
                  >Monday - Friday: {{ chatAvailableHours?.weekDay }}</span
                >
                <span class="d-block"
                  >Saturday: {{ chatAvailableHours?.saturday }}</span
                >
                <span class="d-block"
                  >Bank holidays: {{ chatAvailableHours?.bankHoliday }}</span
                >
              </div>
            </div>

            <v-divider class="mb-7 mt-10"></v-divider>

            <p class="text-medium font-weight-medium font-18 mb-6">
              Other ways we can help
            </p>
            <h3 class="font-weight-bold font-24">
              <v-icon large color="#697283" class="mr-3 mb-1">
                mdi-email </v-icon
              >Email us
            </h3>

            <span class="d-block mb-5">
              You can send an email to our customer services team at:
            </span>
            <a
              class="font-weight-bold text--gray-dark h4 text-decoration-none"
              :class="$vuetify.breakpoint.lgAndUp ? 'font-20' : 'font-18'"
              href="mailto:enquiries@paymentshield.co.uk"
            >
              {{ EMAIL_CONTACT_US }}
            </a>

            <v-divider class="my-4 my-xl-9"></v-divider>

            <v-row v-if="openingHours" class="mt-6 mt-md-0">
              <v-col cols="12">
                <h3 class="mb-2 font-weight-bold font-24">
                  <v-icon large color="#697283" class="mr-2"> mdi-phone </v-icon
                  >Call us
                </h3>

                <div v-if="labelCall">
                  <span class="d-block mb-3">
                    Call the number below to speak to a member of our customer
                    services team.
                  </span>
                  <span class="d-block font-weight-bold mb-3">
                    {{ labelCall }}
                  </span>
                  <a
                    class="text--size-lg text--gray-dark font-weight-bold text-decoration-none font-30"
                    :href="'tel:' + contactInfo?.PhoneNumber"
                  >
                    {{ contactInfo?.PhoneNumber }}
                  </a>
                </div>

                <div v-else>
                  <span class="font-weight-bold"
                    >Sorry! Our contact centre is currently closed.</span
                  >
                  <div class="mt-3">
                    <span class="d-block font-weight-bold">Opening hours</span>
                    <span class="d-block"
                      >Monday - Friday: {{ openingHours?.weekDay }}</span
                    >
                    <span class="d-block"
                      >Saturday: {{ openingHours?.saturday }}</span
                    >
                    <span class="d-block"
                      >Bank holidays: {{ openingHours?.bankHoliday }}</span
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { addD2CScriptHelpshift } from "@/common/utils";
import BaseButton from "@/components/BaseComponents/BaseButton";
import { EMAIL_CONTACT_US } from "@/constants/common.constants";
import appConfigurationService from "@/services/app-configuration.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ContactUs",
  components: {
    BaseButton,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["contactInfo"]),
  },
  data() {
    return {
      openingHours: null,
      chatAvailableHours: null,
      labelCall: "",
      labelChat: "",
      EMAIL_CONTACT_US,
    };
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["getAppConfigurationContactInfo"]),
    openChat() {
      window.Helpshift("open");
    },
    async getBusinessTime() {
      return appConfigurationService
        .getBusinessTime()
        .then((data) => {
          const callTimes = data.businessTimes.filter((item) => {
            return item.type === "Call";
          });

          const chatTimes = data.businessTimes.filter((item) => {
            return item.type === "Chat";
          });

          this.openingHours = this.getTimes(callTimes);
          this.chatAvailableHours = this.getTimes(chatTimes);

          this.labelCall = data.labelCall;
          this.labelChat = data.labelChat;
        })
        .catch((error) => console.log(error));
    },
    getTimes(times) {
      const weekDay = times.find((time) => {
        return time.weekDay === "MondayToFriday";
      });
      const saturday = times.find((time) => {
        return time.weekDay === "Saturday";
      });
      const bankHoliday = times.find((time) => {
        return time.weekDay === "BankHoliday";
      });

      return {
        weekDay: weekDay ? weekDay.openTime + " - " + weekDay.closeTime : "",
        saturday: saturday
          ? saturday.openTime + " - " + saturday.closeTime
          : "",
        bankHoliday: bankHoliday
          ? bankHoliday.openTime + " - " + bankHoliday.closeTime
          : "",
      };
    },
  },
  mounted() {
    this.getAppConfigurationContactInfo();
    this.getBusinessTime();
    addD2CScriptHelpshift();
  },
};
</script>
<style lang="scss" scoped>
.app-container--width-max {
  max-width: 931px !important;
}
.page-content {
  * {
    color: $black-2;
  }
}

.text--gray-dark {
  color: $gray-dark;
}

.v-btn.chat_btn {
  min-width: 290px;
  background: $ocean;
  color: #fff;
  font-weight: bold;
  font-size: 20px !important;
}
.bg {
  &__wrapper {
    background-image: url(~@/assets/images/contact-bg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 384px;
    width: 100%;
  }

  &-info {
    position: absolute;
    top: 55px;
    * {
      color: #fff !important;
    }
  }
}

.block-info {
  margin-top: -200px;
}

.card {
  &__wrapper {
    padding: 38px 32px 56px;
  }
}

hr {
  max-width: calc(100% + 64px);
  width: calc(100% + 64px);
  margin-left: -32px;
}

.lh-small {
  line-height: 1.35;
}

.bg-info {
  max-width: 400px;
  background-color: rgb(0 0 0 / 60%);
  padding: 30px;
  border-radius: 10px;
}
.text--size-small {
  font-size: 14px;
}

@media screen and (max-width: ($grid-breakpoints-lg - 1)) {
  .bg {
    &-info {
      top: 80px;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .v-btn.chat_btn {
    min-width: 100%;
  }
  .bg {
    &__wrapper {
      height: 167px;
    }

    &-info {
      top: 20px;
    }
  }

  .card {
    &__wrapper {
      padding: 32px 24px 50px;
    }
  }

  .block-info {
    margin-top: -100px;
    margin-bottom: 35px;
  }

  hr {
    max-width: calc(100% + 48px);
    width: calc(100% + 48px);
    margin-left: -24px;
  }

  .bg-info {
    max-width: 300px;
    background-color: rgb(0 0 0 / 60%);
    padding: 10px;
    border-radius: 10px;
  }
  .content--padding-small {
    padding: 14px;
  }
}
</style>
